import customAxios from './axios';
import CONFIG from '../../config';

export const getAll = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Customers/GetAll',payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const getIndividual = (id) => {
    return customAxios.get(CONFIG.apiURL + `/Customer/GetCustomer?id=${id}`).then(res => {
        let response = res['data'];
        return response;
    });
};

export const create = (payload) => {
    return customAxios.post(CONFIG.apiURL + '/Customer/CreateCustomer', payload).then(res => {
        let response = res['data'];
        return response;
    });
};

export const update = (payload) => {
    return customAxios.put(CONFIG.apiURL + '/Customer/Update', payload).then(res => {
        let response = res['data'];
        return response;
    });
};